import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ModalBox from 'components/application/ModalBox';

export default function ResetTableToDefaultConfirmationModal({
  isOpen,
  onClose,
  onResetTableToDefaultClick,
}) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix:
      'projectsDashboard.components.ResetTableToDefaultConfirmationModal',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            {i18nTShared('cancel')}
          </TextButton>
          <FilledButton color='red' onClick={onResetTableToDefaultClick}>
            {i18nT('button')}
          </FilledButton>
        </div>
      }
      isOpen={isOpen}
      mode='flexible'
      onClose={onClose}
    >
      <div className='tw-p-6'>
        <h2 className='tw-m-0 tw-mb-6 tw-p-0 tw-text-xl tw-font-semibold tw-tracking-tight tw-text-grey-900'>
          {i18nT('title')}
        </h2>
        <p className='tw-m-0 tw-p-0 tw-text-m tw-font-normal tw-text-grey-700'>
          {i18nT('description')}
        </p>
      </div>
    </ModalBox>
  );
}

ResetTableToDefaultConfirmationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onResetTableToDefaultClick: PropTypes.func.isRequired,
};
